/* eslint-disable jsx-a11y/anchor-is-valid */

import {
  FC,
  useState,
  useEffect,
  useRef
} from 'react'

import { useIntl } from 'react-intl'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import {
  KTSVG,
  toAbsoluteUrl
} from '../../../_metronic/helpers'

import {
  parseWeekDays,
} from '../../services/dates'

import { useLocation } from 'react-router-dom'
import { Modal } from "react-bootstrap";

const CancelSchedule = ({
  isOpen,
  onClosed,
  withCredit,
  withPayment,
  creditLimitWeekday,
  creditLimitStartAt,
  creditLimitEndAt,
  onChange,
  isLoading,
}) => {
  const { schedules } = useSelector((state : any) => ({
    schedules: state.schedules,
  }), shallowEqual);

  const intl = useIntl();
  const location = useLocation();
  const dispatch = useDispatch();

  const [selectedFields, setSelectedFields] = useState<any>([]);

  // useEffect(() => {
  //   if (isOpen) {
  //     setSelectedFields(selected);
  //   }
  // }, [isOpen]);

  const confirm = () => {
    onClosed();
  }

  // const selectField = (id) => {
  //   if(!selectedFields.includes(id)) {
  //     setSelectedFields([...selectedFields, id]);
  //   } else{
  //       var array = [...selectedFields];
  //       var index = array.indexOf(id);

  //       if (index !== -1) {
  //         array.splice(index, 1);

  //         setSelectedFields(array);
  //       }
  //   }
  // }

  return (
    <>
      <Modal
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={true}
        show={isOpen}
        onHide={() => onClosed()}
        dialogClassName="custom-modal mw-600px"
        className="bg-black bg-opacity-50"
      >
          <Modal.Header>
            <Modal.Title id="cancel-schedule-title" className="py-2 flex-root d-flex justify-content-center">
                <h2>
                  <span className="text-white fd-uppercase">Cancelar agendamento</span>
                </h2>
            </Modal.Title>

            <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => onClosed()}>
              <span className="svg-icon svg-icon-1">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor" />
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor" />
                </svg>
              </span>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="mx-auto mw-500px w-100 pt-0 mb-5">
              <div className="justify-content-space-between d-flex mb-10">
                <span className="flex-root text-center fs-3 text-primary fw-bold mx-md-20">
                  {(withCredit || withPayment) && `Escolha a forma de estorno para efetuar o cancelamento do seu agendamento`}
                  {(!withCredit && !withPayment) && `Deseja cancelar seu agendamento?`}
                </span>
              </div>

              {withCredit && <>
                <div className="justify-content-space-between d-flex flex-column mb-5">
                  <span className="flex-root text-center fs-5 text-gray-900 mx-md-20">
                    Receber 01 crédito para reservar sua quadra com válidade de 30 dias.
                  </span>
                  {creditLimitWeekday && creditLimitStartAt && creditLimitEndAt && <span className="flex-root text-center fs-7 text-gray-700 mx-md-20">
                    Limite de uso de {parseWeekDays(creditLimitWeekday, true)} das {creditLimitStartAt} até {creditLimitEndAt}
                  </span>}
                </div>
                <div className="mb-0 text-center">
                  <button
                    className={`btn border bg-gray-500 btn-active-primary w-250px ${schedules.actionsLoading && 'btn-primary'}`}
                    onClick={() => onChange('credit')}
                    disabled={schedules.actionsLoading}
                  >
                    {(!schedules.actionsLoading) && <span className="indicator-label">RECEBER 1 CRÉDITO</span>}
                    {(schedules.actionsLoading) && <span className="indicator-label">
                      Carregando... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span>}
                  </button>
                </div>
              </>}

              {(withCredit && withPayment) && <div className="separator my-5"></div>}

              {withPayment && <>
                <div className="justify-content-space-between d-flex mb-5">
                  <span className="flex-root text-center fs-5 text-gray-900 mx-md-20">
                    Solicitar o estorno do valor pago via operadora
                  </span>
                </div>

                <div className="mb-0 text-center">
                  <button
                    className={`btn bg-gray-500 btn-active-danger w-250px ${schedules.actionsLoading && 'btn-danger'}`}
                    onClick={() => onChange('chargeback')}
                    disabled={schedules.actionsLoading}
                  >
                    {(!schedules.actionsLoading) && <span className="indicator-label">ESTORNAR PAGAMENTO</span>}
                    {(schedules.actionsLoading) && <span className="indicator-label">
                      Carregando... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span>}
                  </button>
                </div>
              </>}

              {(!withCredit && !withPayment) && <>
                <div className="justify-content-space-between d-flex mb-5">
                  <span className="flex-root text-center fs-5 text-gray-900 mx-md-20">
                  Seu agendamento será cancelado, o horário será liberado para agendamento
                  </span>
                </div>

                <div className="mb-0 text-center">
                  <button
                    className={`btn bg-gray-500 btn-active-danger w-250px ${schedules.actionsLoading && 'btn-danger'}`}
                    onClick={() => onChange()}
                    disabled={schedules.actionsLoading}
                  >
                    {(!schedules.actionsLoading) && <span className="indicator-label">CANCELAR AGENDAMENTO</span>}
                    {(schedules.actionsLoading) && <span className="indicator-label">
                      Carregando... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span>}
                  </button>
                </div>
              </>}

              {schedules.error && (typeof schedules.error) == "string" && <div className='d-flex mt-5 justify-content-center'>
                <div className='fv-row'>
                  <div className="alert bg-light-primary d-flex flex-column flex-sm-row p-5 mb-10">
                    <div className="d-flex flex-column text-primary pe-0 pe-sm-10">
                      <h5 className="mb-1">Erro na solicitação</h5>
                      <span>{schedules.error}</span>
                    </div>
                  </div>
                </div>
              </div>}
            </div>
          </Modal.Body>
      </Modal>
    </>
  )
}

export {
  CancelSchedule
}
